import React, {Component} from "react";
import {ValidateTool} from "../../utils/utilsTools";
import {BridgeHelper} from "../../utils/bridgeHelper";
import {GetH5ContainerURL, H5RouteName, RouteName} from "../../common/routeName";
import {Color} from "../../common/styles";
import {languagePackage} from "../../common/language";
import {FeedbackService} from "./feedbackService";
import {LogEventName} from "../../grayLog/logKey";


export default class FeedbackEdit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: window.userAccount?.Email || '',
            content: '',
            errMsgForEmail: '',
            errMsgForContent: ''
        };

        this.feedbackType = window.passProps?.feedbackType || languagePackage().GeneralFeedback;
        this.feedbackService = new FeedbackService();
    }

    onSendSuccess() {
        let passProps = {
            url: GetH5ContainerURL(H5RouteName.feedback.confirm),
            style: {backgroundColor: Color.white},
            closeToRoot: true
        };
        BridgeHelper.pushPage(RouteName.bridgeWebView, languagePackage().Confirmation, passProps);
    }

    sendFeedback = () => {
        let {email, content} = this.state;

        if (!email.length) {
            this.setState({errMsgForEmail: languagePackage().PleaseEnterEmailAddress});
            return;
        } else if (!ValidateTool.verifyEmail(email)) {
            this.setState({errMsgForEmail: languagePackage().PleaseEnterValidEmail});
            return;
        }

        if (!content.length) {
            this.setState({errMsgForContent: languagePackage().PleaseEnterFeedbackDetails});
            return;
        }

        let userAccount = window.userAccount || {};
        let {UserID, FirstName, LastName} = userAccount;

        let param = {
            UserID: UserID || '',
            EMail: email,
            FirstName: FirstName || '',
            LastName: LastName || '',
            type: this.feedbackType,
            content: content
        };

        this.feedbackService.submitPatientFeedback(param, () => {
            this.onSendSuccess();
            BridgeHelper.grayLogEvent(LogEventName.sendFeedback, {successful: true});
        }, (error) => {
            BridgeHelper.showToast(error?.message || languagePackage().RequestFailed);
            BridgeHelper.grayLogEvent(LogEventName.sendFeedback, {successful: false, errMsg: error?.message});
        })
    }

    render() {
        let {email, content, errMsgForEmail, errMsgForContent} = this.state;
        return (
            <div className={'w-full h-full flex flex-col p-5'}>
                <div className={'font-semibold text-lg text-primary'}>{this.feedbackType}</div>
                <div className={'mt-6'}>
                    <div className={'font-normal text-base text-primary'}>{languagePackage().Email}</div>
                    <input
                        className={'w-full mt-2 h-12 border-b border-lightGray rounded-none text-lg'}
                        type={"email"}
                        value={email}
                        onChange={(event) => {
                            let email = event.target.value;
                            let errMsgForEmail = '';
                            if (!email.length) {
                                errMsgForEmail = languagePackage().PleaseEnterEmailAddress;
                            } else if (!ValidateTool.verifyEmail(email)) {
                                errMsgForEmail = languagePackage().PleaseEnterValidEmail;
                            }
                            this.setState({email: email, errMsgForEmail: errMsgForEmail});
                        }}
                    />
                    {errMsgForEmail ? <div className={'mt-1.5 font-normal text-sm text-red-500'}>{errMsgForEmail}</div> : null}
                </div>
                <div className={'mt-6'}>
                    <div className={'font-normal text-base text-primary'}>{languagePackage().FeedbackDetails}</div>
                    <textarea
                        className={'w-full h-40 mt-2 px-1 border border-lightGray text-lg'}
                        maxLength={500}
                        value={content}
                        placeholder={languagePackage().FeedbackContentPlaceholder}
                        onChange={(event) => {
                            let content = event.target.value;
                            this.setState({content: content, errMsgForContent: content ? '' : languagePackage().PleaseEnterFeedbackDetails});
                        }}
                    />
                    <div className={'flex justify-between'}>
                        <div className={'font-normal text-sm text-red-500'}>{errMsgForContent}</div>
                        <div className={'font-normal text-sm text-primary'}>{`${content.length}/500`}</div>
                    </div>
                </div>

                <div className={"mt-24 px-10"}>
                    <div className={'flex flex-col justify-center items-center h-12 rounded-full px-6 py-2.5 bg-primary overflow-hidden'}
                        onClick={this.sendFeedback}
                    >
                        <p className={'font-semibold text-base text-white truncate'}>{languagePackage().SendFeedback}</p>
                    </div>
                </div>
            </div>
        )
    }
}
